import { useCallback, useContext } from 'react';
import { dateClient } from '@utils/date-client';
import { TimeZoneContext } from '@contexts/timezone-context';
const useGenericEventProcessor = () => {
    const { timezone } = useContext(TimeZoneContext);
    const processGenericEvent = useCallback((genericEvent) => {
        const processedGenericEvent = Object.assign(Object.assign(Object.assign({}, genericEvent), { start: dateClient(genericEvent.start).tz(timezone), end: dateClient(genericEvent.end).tz(timezone) }), (genericEvent.recurrence && {
            recurrence: Object.assign(Object.assign({}, genericEvent.recurrence), { endDate: genericEvent.recurrence.endDate
                    ? dateClient(genericEvent.recurrence.endDate).tz('UTC', true)
                    : undefined, occurrencesEndDate: genericEvent.recurrence.occurrencesEndDate
                    ? dateClient(genericEvent.recurrence.occurrencesEndDate).tz(timezone)
                    : undefined })
        }));
        return processedGenericEvent;
    }, [timezone]);
    return { processGenericEvent };
};
export default useGenericEventProcessor;
